document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const menuButton = document.querySelector('.menu-button');
const mobileMenu = document.querySelector('#MobileMenu');
const closeButton = document.querySelector('.mobile-close');

function setMenu(open) {
  if (!menuButton || !mobileMenu) return;
  menuButton.setAttribute('aria-expanded', String(open));
  mobileMenu.hidden = !open;
  document.body.classList.toggle('menu-open', open);
}

menuButton?.addEventListener('click', () => setMenu(true));
closeButton?.addEventListener('click', () => setMenu(false));
mobileMenu?.addEventListener('click', (event) => {
  if (event.target === mobileMenu || event.target.closest('a')) setMenu(false);
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') setMenu(false);
});

document.querySelectorAll('[data-quantity-button]').forEach((button) => {
  button.addEventListener('click', () => {
    const input = document.getElementById(button.getAttribute('aria-controls'));
    if (!input) return;
    const next = Number(input.value || 1) + Number(button.dataset.change || 0);
    input.value = Math.max(Number(input.min || 0), next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
});

document.querySelectorAll('[data-sort-by]').forEach((select) => {
  select.addEventListener('change', () => select.form?.submit());
});

document.querySelectorAll('[data-product-select]').forEach((select) => {
  select.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    const price = document.querySelector('[data-product-price]');
    const button = document.querySelector('[data-add-to-cart]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    const compare = document.querySelector('[data-product-compare]');
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }
    if (button) {
      const available = option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? 'Add to cart' : 'Sold out';
    }
    if (history.replaceState && option.value) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState({}, '', url);
    }
  });
});

if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
  const targets = document.querySelectorAll('.section-heading, .product-card, .category-card, .proof-grid article, .trust-bar > div, .standard-copy, .inquiry-copy, .faq-list details');
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('in-view'); io.unobserve(entry.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px' });
  targets.forEach((el) => { el.classList.add('reveal'); io.observe(el); });
}
